import { ApplicationModel } from './applicationsModel';
import { practiceConnectApi } from '../practiceConnectApi';
import { AxiosResponse } from 'axios';
import constants from '../../../../utils/constants';

export const getAvailableApplications = (): Promise<AxiosResponse<ApplicationModel[]>> => {
  return practiceConnectApi.get(`${constants.PROJECT_CONNECT_API_BASE_URL}/v1/applications`);
};
